import { Navigate, useLocation } from 'react-router-dom';
import type { EmployeeRole } from '@trackkm/shared';
import { useAuthStore } from '@/stores/auth';

interface AuthGuardProps {
  readonly children: React.ReactNode;
  readonly allowedRoles?: readonly EmployeeRole[];
}

export function AuthGuard({ children, allowedRoles }: AuthGuardProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const employee = useAuthStore((s) => s.employee);
  const mustChangePin = useAuthStore((s) => s.mustChangePin);
  const location = useLocation();

  if (!isAuthenticated || !employee) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Force PIN change on first login — allow only the change-pin page
  if (mustChangePin && location.pathname !== '/change-pin') {
    return <Navigate to="/change-pin" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(employee.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
